import { useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import CustomTab from "../../../components/custom_tab/CustomTab";
import PayrollCompanyLayout from "../../../components/layouts/PayrollCompanyLayout";
import EmployeesHistory from "./views/EmployeesHistory";
import useUserStore from "../../../state-management/useUserStore";
import HumanResourceLayout from "../../../components/layouts/HumanResourceLayout";
import { PERMISSIONS, useValidateUserPermissions } from "../../../helpers/usePermissionManager";

const Reports = () => {
	const hasPermission = useValidateUserPermissions([PERMISSIONS.REPORTS_EMPLOYEE_READ]);
	const { userType } = useUserStore();
	const LAYOUT = useMemo(() => {
		switch(userType) {
			case "ORGANIZATION": 
				return PayrollCompanyLayout;
			default: 
				return HumanResourceLayout;
		}
	}, [userType])
	const [searchParams] = useSearchParams();
	const [view, setView] = useState(
		searchParams.get("view") || "employeesHistory"
	);
	
	return (hasPermission && (<>
			<LAYOUT>
				<Helmet>
					<title>Reports |{userType === "HR" ? " HR " : " Company "}Flow</title>
				</Helmet>
				<h1 className="font-bold text-xl mb-8">Reports</h1>
				<CustomTab
					view={view}
					setView={setView}
					tabColumns={tabColumns}
				>
					{view === "employeesHistory" && <EmployeesHistory />}
				</CustomTab>
			</LAYOUT>
	</>));
};

export default Reports;

const tabColumns = [
	{
		id: 1,
		view: "employeesHistory",
		name: "Employees History",
	},
];